import { render, staticRenderFns } from "./mobileCheck.vue?vue&type=template&id=7bfd520c&scoped=true"
import script from "./mobileCheck.vue?vue&type=script&lang=js"
export * from "./mobileCheck.vue?vue&type=script&lang=js"
import style0 from "./mobileCheck.vue?vue&type=style&index=0&id=7bfd520c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfd520c",
  null
  
)

export default component.exports